import React, { Component } from 'react';
import PropTypes from 'prop-types';

import TitleDemandStatesMap from '../../../components/statesMap/countyLevel/titleDemandStatesMap';
import TitleLocationStatesMap from '../../../components/statesMap/countyLevel/titleLocationStatesMap';
import TitleSalaryStatesMap from '../../../components/statesMap/countyLevel/titleSalaryStatesMap';

const HEATMAPS = {
  TITLE_SALARY: 'TITLE_SALARY',
  TITLE_LOCATION: 'TITLE_LOCATION',
  TITLE_DEMAND: 'TITLE_DEMAND',
};

const ARTICLE_SUBTYPES = {
  INTRO: 'division-by-location-section',
  TITLE_SALARY: 'where-earn-more-section',
  TITLE_LOCATION: 'where-are-located-section',
  TITLE_DEMAND: 'where-are-demand',
};

const propTypes = {
  heatmapsData: PropTypes.objectOf(PropTypes.any).isRequired,
  criteria: PropTypes.objectOf(PropTypes.any).isRequired,
  onAllHeatmapsLoadError: PropTypes.func.isRequired,
  articleData: PropTypes.arrayOf(PropTypes.object),
  demographicsData: PropTypes.objectOf(PropTypes.any),
};

const defaultProps = {
  articleData: [],
  demographicsData: {},
};

class HeatmapsSection extends Component {
  constructor(props) {
    super(props);

    const { _getArticleBySubtype } = this;
    const { demographicsData } = props;
    const { salaryMapExists, demandMapExists, supplyMapExists } = demographicsData || {};

    this.state = {
      showHeatmap: {
        [HEATMAPS.TITLE_SALARY]: !!salaryMapExists,
        [HEATMAPS.TITLE_LOCATION]: !!supplyMapExists,
        [HEATMAPS.TITLE_DEMAND]: !!demandMapExists,
      },
      articles: {
        intro: _getArticleBySubtype(ARTICLE_SUBTYPES.INTRO),
        titleSalary: _getArticleBySubtype(ARTICLE_SUBTYPES.TITLE_SALARY),
        titleLocation: _getArticleBySubtype(ARTICLE_SUBTYPES.TITLE_LOCATION),
        titleDemand: _getArticleBySubtype(ARTICLE_SUBTYPES.TITLE_DEMAND),
      },
    };
  }

  _onMapLoadError = (error, type) => {
    this.setState((prevState) => ({
      showHeatmap: {
        ...prevState.showHeatmap,
        [type]: false,
      },
    }));
  };

  _getArticleBySubtype = (articleSubtype = '') => {
    const { articleData } = this.props;

    if (!articleData || !Array.isArray(articleData) || !articleData.length) {
      return '';
    }

    const article = articleData.find(
      (articleDataItem) => articleDataItem.post_subtype === articleSubtype
    );
    if (article && article.content && article.content.length) {
      return article.content;
    }
    return '';
  };

  render() {
    const { _onMapLoadError } = this;
    const { criteria, heatmapsData = {}, onAllHeatmapsLoadError } = this.props;
    const { showHeatmap, articles } = this.state;
    const {
      titleSalaryStatesMapOriginalUrl,
      titleLocationStatesMapOriginalUrl,
      titleDemandStatesMapOriginalUrl,
      titleSalaryStatesMapWidgetUrl,
      titleLocationStatesMapWidgetUrl,
      titleDemandStatesMapWidgetUrl,
    } = heatmapsData;

    const { jobTitlePlural, title } = criteria;

    const {
      intro: introArticle,
      titleSalary: titleSalaryArticle,
      titleLocation: titleLocationoArticle,
      titleDemand: titleDemandArticle,
    } = articles;

    const showTitleSalaryHeatmap = showHeatmap[HEATMAPS.TITLE_SALARY];
    const showTitleLocationHeatmap = showHeatmap[HEATMAPS.TITLE_LOCATION];
    const showTitleDemandHeatmap = showHeatmap[HEATMAPS.TITLE_DEMAND];

    const hideAllHeatmaps = !Object.keys(showHeatmap)
      .map((key) => showHeatmap[key])
      .some(Boolean);
    if (hideAllHeatmaps) {
      onAllHeatmapsLoadError();
      return <></>;
    }

    return (
      <div className="row">
        <div className="col-xl-8">
          <h2 className="brandonH2 z-mb-48 w-730">{`${title} Heatmaps`}</h2>
          {introArticle && (
            <div
              className="demographics-heatmap-intro w-730"
              dangerouslySetInnerHTML={{ __html: introArticle }}
            />
          )}
          {showTitleSalaryHeatmap && (
            <>
              <div className="demographics-heatmap demographics-heatmap-salary">
                <p className="demographics-heatmap-title w-730">
                  {`Where Do ${jobTitlePlural} Earn The Most?`}
                </p>
                {titleSalaryArticle && (
                  <div
                    className="demographics-heatmap-description w-730"
                    dangerouslySetInnerHTML={{ __html: titleSalaryArticle }}
                  />
                )}
                <TitleSalaryStatesMap
                  key={HEATMAPS.TITLE_SALARY}
                  title={title}
                  name="whereDoEarnTheMost"
                  onMapLoadError={(error) => _onMapLoadError(error, HEATMAPS.TITLE_SALARY)}
                  embedWidgetUrl={titleSalaryStatesMapWidgetUrl}
                  originalUrl={titleSalaryStatesMapOriginalUrl}
                  isEmbeddable
                />
              </div>
            </>
          )}
          {showTitleLocationHeatmap && (
            <>
              <div className="demographics-heatmap demographics-heatmap-location">
                <p className="demographics-heatmap-title w-730">
                  {`Which State Has The Most ${jobTitlePlural}?`}
                </p>
                {titleLocationoArticle && (
                  <div
                    className="demographics-heatmap-description w-730"
                    dangerouslySetInnerHTML={{ __html: titleLocationoArticle }}
                  />
                )}
                <TitleLocationStatesMap
                  key={HEATMAPS.TITLE_LOCATION}
                  title={title}
                  name="whereAreLocated"
                  jobTitlePlural={jobTitlePlural}
                  onMapLoadError={(error) => _onMapLoadError(error, HEATMAPS.TITLE_LOCATION)}
                  embedWidgetUrl={titleLocationStatesMapWidgetUrl}
                  originalUrl={titleLocationStatesMapOriginalUrl}
                  isEmbeddable
                />
              </div>
            </>
          )}
          {showTitleDemandHeatmap && (
            <>
              <div className="demographics-heatmap demographics-heatmap-openings">
                <p className="demographics-heatmap-title w-730">
                  {`Where Are ${jobTitlePlural} In High Demand?`}
                </p>
                {titleDemandArticle && (
                  <div
                    className="demographics-heatmap-description w-730"
                    dangerouslySetInnerHTML={{ __html: titleDemandArticle }}
                  />
                )}
                <TitleDemandStatesMap
                  key={HEATMAPS.TITLE_DEMAND}
                  title={title}
                  name="whereAreInHighDemand"
                  onMapLoadError={(error) => _onMapLoadError(error, HEATMAPS.TITLE_DEMAND)}
                  embedWidgetUrl={titleDemandStatesMapWidgetUrl}
                  originalUrl={titleDemandStatesMapOriginalUrl}
                  isEmbeddable
                />
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}

HeatmapsSection.propTypes = propTypes;
HeatmapsSection.defaultProps = defaultProps;

export default HeatmapsSection;
